const translations = {
  // sidebar
  "select-patient": {
    "en": "Select Patient",
    "es": "Seleccionar Paciente"
  },
  "initial-information": {
    "en": "Initial Information",
    "es": "Información inicial"
  },
  "additional-information": {
    "en": "Additonal Information",
    "es": "Información adicional"
  },
  "change-location": {
    "en": "Change Location",
    "es": "Cambiar ubicación"
  },
  "select-appointment": {
    "en": "Select Appointment",
    "es": "Seleccionar cita"
  },
  "review-details": {
    "en": "Review Details",
    "es": "Detalles de la revisión",
  },
  "confirmation": {
    "en": "Confirmation",
    "es": "Confirmación",
  },

  // select patient 
  "who-is-scheduling": {
    "en": "Who are you scheduling for?",
    "es": "¿Para quién estás programando?",
  },

  // initial content
  "how-can-we-help": {
    "en": "How can we help?",
    "es": "¿Cómo podemos ayudar?"
  },
  "cleaning-and-regular-checkup": {
    "en": "Cleaning & Regular check-up",
    "es": "Limpieza y chequeo regular"
  },
  "tooth-pain-emergency-other": {
    "en": "Tooth pain / Emergency / Other",
    "es": "Dolor de muelas / Emergencia / Otro"
  },
  "select-location": {
    "en": "Select Location",
    "es": "Seleccionar ubicación"
  },  
  "patient-age-group-label": {
    "en": "Are you scheduling for an adult or child (under age of 21)?",
    "es": "¿Está programando para un adulto o un niño (menor de 21 años)?"
  },
  "adult": {
    "en": "Adult",
    "es": "Adulto"
  },
  "child-under-21": {
    "en": "Child (under 21 years old)",
    "es": "Niño (menor de 21 años)"
  },
  "parent-guardian-information": {
    "en": "Parent / Guardian Information",
    "es": "Información de padres/tutores"
  },
  "parent-guardian-first-name": {
    "en": "Parent/Guardian First Name",
    "es": "Nombre primero del padre / tutor"
  },
  "parent-guardian-last-name": {
    "en": "Parent/Guardian Last Name",
    "es": "Apellido del padre / tutor"
  },
  "patient-information": {
    "en": "Patient Information",
    "es": "Información del paciente"
  },
  "patient-first-name": {
    "en": "Patient First Name",
    "es": "Nombre del paciente"
  },
  "patient-last-name": {
    "en": "Patient Last Name",
    "es": "Apellido del paciente"
  },
  "patient-birth-day": {
    "en": "Patient Birth Day",
    "es": "Día de nacimiento del paciente"
  },
  "patient-birth-month": {
    "en": "Patient Birth Month",
    "es": "Mes de nacimiento del paciente"
  },
  "january": {
    "en": "January",
    "es": "Enero"
  },
  "february": {
    "en": "February",
    "es": "Febrero"
  },
  "march": {
    "en": "March",
    "es": "Marzo"
  },
  "april": {
    "en": "April",
    "es": "Abril"
  },
  "may": {
    "en": "May",
    "es": "Mayo"
  },
  "june": {
    "en": "June",
    "es": "Junio"
  },
  "july": {
    "en": "July",
    "es": "Julio"
  },
  "august": {
    "en": "August",
    "es": "Agosto"
  },
  "september": {
    "en": "September",
    "es": "Septiembre"
  },
  "october": {
    "en": "October",
    "es": "Octubre"
  },
  "november": {
    "en": "November",
    "es": "Noviembre"
  },
  "december": {
    "en": "December",
    "es": "Diciembre"
  },
  "patient-birth-year": {
    "en": "Patient Birth Year",
    "es": "Año de nacimiento del paciente"
  },
  "phone-number": {
    "en": "Phone Number",
    "es": "Número de teléfono"
  },
  "please-match-phone-format": {
    "en": "Phone number must be exactly 10 digits",
    "es": "El número de teléfono debe tener exactamente 10 dígitos",
  },  
  "email": {
    "en": "Email",
    "es": "Correo electrónico"
  },
  "continue": {
    "en": "Continue",
    "es": "Continuar"
  },

  // additional info
  "additional-patient-info": {
    "en": "Additional Patient Info",
    "es": "Información adicional del paciente"
  },
  "patient-gender": {
    "en": "Patient's Gender",
    "es": "Sexo del paciente"
  },
  "male": {
    "en": "Male",
    "es": "Masculino"
  },
  "female": {
    "en": "Female",
    "es": "Femenino"
  },
  "address": {
    "en": "Address",
    "es": "Dirección"
  },
  "city": {
    "en": "City",
    "es": "Ciudad"
  },
  "state": {
    "en": "State",
    "es": "Estado"
  },
  "zip": {
    "en": "Zip",
    "es": "Codigo de Area"
  },
  "zip-requirement": {
    "en": "Your zip code must be exactly 5 digits",
    "es": "Su código postal debe tener exactamente 5 dígitos"
  },
  "insurance": {
    "en": "Insurance",
    "es": "Seguro"
  },
  "insurance-type": {
    "en": "Insurance Type",
    "es": "Tipo de seguro"
  },
  "insurance-name": {
    "en": "Insurance Name",
    "es": "Nombre del seguro",
  },
  "medicaid-id": {
    "en": "Medicaid ID",
    "es": "ID de Medicaid",
  },
  "insurance-subscriber-first-name": {
    "en": "Subscriber First Name",
    "es": "Nombre del suscriptor",
  },
  "insurance-subscriber-last-name": {
    "en": "Subscriber Last Name",
    "es": "Apellido del suscriptor",
  },
  "insurance-subscriber-birth-month": {
    "en": "Subscriber Birth Month",
    "es": "Mes de nacimiento del suscriptor",
  },
  "insurance-subscriber-birth-day": {
    "en": "Subscriber Birth Day",
    "es": "Día del nacimiento del suscriptor",
  },
  "insurance-subscriber-birth-year": {
    "en": "Subscriber Birth Year",
    "es": "Año de nacimiento del suscriptor",
  },
  "insurance-member-id": {
    "en": "Insurance Member ID",
    "es": "ID de miembro del seguro",
  },
  "insurance-company-phone": {
    "en": "Insurance Company Phone Number",
    "es": "Número de teléfono de la compañía de seguros",
  },
  "insurance-group-number": {
    "en": "Group Number",
    "es": "Número de grupo",
  },

  //existing patient
  "manage-appointment": {
    "en": "Manage Appointment",
    "es": "Gestionar cita"
  },

  // select appointment
  "current-location": {
    "en": "Current Location",
    "es": "Ubicación actual"
  },
  "need-to-change-office": {
    "en": "Need to change your office?",
    "es": "¿Necesitas cambiar de oficina?"
  },
  "select-appointment-date": {
    "en": "Please select desired appointment date",
    "es": "Por favor seleccione la fecha de cita deseada",
  },
  "day": {
    "en": "Day",
    "es": "Día"
  },
  "month": {
    "en": "Month",
    "es": "Mes"
  },
  "year": {
    "en": "Year",
    "es": "Año"
  },
  "search-available-times": {
    "en": "Search Available Times",
    "es": "Buscar horarios disponibles"
  },
  "select-time-to-continue": {
    "en": "Please select a time to continue!",
    "es": "¡Selecciona una hora para continuar!"
  },

  // final
  "verify-age": {
    "en": "By submitting this form, I certify that I am 18 years or older.",
    "es": "Al enviar este formulario, certifico que tengo 18 años o más..",
  },
  "submit": {
    "en": "Submit",
    "es": "Entregar"
  },
}


function getTranslation(slug){
  let translation = `Translation for ${slug} not found`;

  if(translations.hasOwnProperty(slug)){
    translation = window.location.href.indexOf('/es/') != -1 ? translations[slug].es : translations[slug].en
  }

  return translation
}

export default getTranslation